"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useActions", {
  enumerable: true,
  get: function () {
    return _useActions.useActions;
  }
});
Object.defineProperty(exports, "Status", {
  enumerable: true,
  get: function () {
    return _types.Status;
  }
});
exports.useAttachments = exports.useDispatch = exports.useState = exports.AttachmentsProvider = void 0;

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var _reducer = require("./reducer");

var _useActions = require("./useActions");

var _types = require("./types");

const stateContext = /*#__PURE__*/React.createContext(undefined);
const dispatchContext = /*#__PURE__*/React.createContext(undefined);
const AttachmentsProvider = (0, _blocks.createProvider)(stateContext, dispatchContext, _reducer.reducer, _reducer.initialState);
exports.AttachmentsProvider = AttachmentsProvider;
const useState = (0, _blocks.createStateHook)(stateContext);
exports.useState = useState;
const useDispatch = (0, _blocks.createDispatchHook)(dispatchContext);
exports.useDispatch = useDispatch;
const useAttachments = (0, _blocks.createContextHook)(stateContext, dispatchContext);
exports.useAttachments = useAttachments;